<!-- Toast Notification -->
<div class="toast-msg-container" *ngIf="showToast">
  <div class="toast-msg" [style.backgroundColor]="isSuccess ? '#73d76a' : '#f54b4b'">
    {{ notificationMsg }}
  </div>
</div>

<!-- Loading Spinner -->
<div *ngIf="isLoading" class="loading">
  <div class="spinner-border m-auto" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>

<!-- Revoke Confirmation Popup -->
<div *ngIf="showRevokeConfirm" class="modal fade show" id="revokeModalCenter" tabindex="-1" aria-modal="true"
    aria-labelledby="revokeModalCenterTitle" style="display: block; background: #00000030;" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="revokeModalCenterTitle">Confirm Revoke</h5>
                <button (click)="cancelRevoke()" type="button" class="close" data-dismiss="modal"
                    aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <p>Are you sure you want to log out <strong>{{ pendingRevokeDevice?.name }}</strong>?</p>
            </div>
            <div class="modal-footer">
                <div class="row w-100">
                    <div class="col-6 p-0 pr-1">
                        <button (click)="cancelRevoke()" class="btn btn-secondary button-base w-100"
                            style="background: #ABACAD;">
                            No
                        </button>
                    </div>
                    <div class="col-6 p-0 pr-1">
                        <button (click)="revokeAccess(pendingRevokeDevice)" class="btn button-base btn-danger w-100">
                            Yes
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Main Content -->
<div *ngIf="!isLoading">
  
  <!-- Empty State -->
  <div *ngIf="devices.length === 0" class="empty-state">
    <span class="material-icons empty-icon">devices_other</span>
    <div class="empty-text">No other active devices found</div>
  </div>

  <!-- Device List -->
  <div class="orderItem d-flex p-2 my-3" *ngFor="let device of devices">
    <div class="row no-gutters w-100" style="overflow: hidden;">
      <div class="col-12 text-truncate" style="font-size:12px;">{{ device.name }}</div>

      <div class="col-12 d-flex justify-content-between">
        <div class="d-flex flex-column">
          <div class="orderId">
            {{ device.type }}
          </div>
          <div class="date">
            {{ device.createdDate | date }}
          </div>
          <div class="">
            <span class="badge" [ngClass]="device.isActive ? 'bg-success' : 'bg-secondary'">
              {{ device.isActive ? 'Active' : 'Inactive' }}
            </span>
          </div>
        </div>
        <div class="d-flex flex-column">
          <div class="mt-auto d-flex justify-content-end align-items-center">
            <button class="btn btn-outline-danger d-flex justify-content-center align-items-center text-center"
              (click)="confirmRevoke(device)">
              <span class="material-icons text-danger mr-1">delete</span>Revoke Access
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
